var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenMenuProfil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01369 0.261434C1.10323 0.17529 1.22331 0.128218 1.34753 0.130562C1.47176 0.132906 1.58997 0.184474 1.67619 0.273934L3.99494 2.73518L6.31369 0.273934C6.35584 0.227468 6.40689 0.189936 6.46381 0.16356C6.52073 0.137185 6.58236 0.122503 6.64506 0.120385C6.70776 0.118266 6.77024 0.128754 6.82881 0.151228C6.88738 0.173701 6.94085 0.207703 6.98603 0.251217C7.03122 0.294732 7.06722 0.346874 7.09188 0.404554C7.11655 0.462235 7.12939 0.52428 7.12964 0.587013C7.12988 0.649746 7.11754 0.71189 7.09333 0.769764C7.06912 0.827637 7.03354 0.880063 6.98869 0.923934L4.33244 3.73643C4.28872 3.7818 4.23629 3.81789 4.17831 3.84253C4.12032 3.86718 4.05795 3.87988 3.99494 3.87988C3.93194 3.87988 3.86957 3.86718 3.81158 3.84253C3.7536 3.81789 3.70117 3.7818 3.65744 3.73643L1.00119 0.923934C0.915051 0.834397 0.867979 0.714323 0.870323 0.590097C0.872667 0.465871 0.924235 0.347657 1.01369 0.261434Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenuProfil);
export default __webpack_public_path__ + "static/media/OpenMenuProfil.9b2a7aa715fdedf6cb964906f9eb826f.svg";
export { ForwardRef as ReactComponent };